import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { IClientPortalAccountContactDetailsService } from "services/ClientPortalAccountContactDetailsService";
import { IClientPortalUsersService } from "services/ClientPortalUsersService";
import { ISessionService } from "services/SessionService";
import { ClientContactDetailsModel } from "services/api/cplapi/CPLAPI";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";
import { container } from "setup/dependency/inversify.config";
import { RootState } from "setup/redux/RootReducer";

const initialState = {
  LoadingContactDetails: false,
  ClientContactDetails: new Array<ClientContactDetailsModel>(),
};

export const LinkedAccountsSlice = createSlice({
  name: "LinkedAccounts",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getLinkedAccounts.pending, (state) => {
        state.LoadingContactDetails = true;
      })
      .addCase(getLinkedAccounts.fulfilled, (state, action) => {
        state.LoadingContactDetails = false;
        state.ClientContactDetails = action.payload;
      })
      .addCase(getLinkedAccounts.rejected, (state) => {
        state.LoadingContactDetails = false;
        state.ClientContactDetails = new Array<ClientContactDetailsModel>();
      })
      .addCase(unlinkClientAccount.pending, (state) => {
        state.LoadingContactDetails = true;
      })
      .addCase(unlinkClientAccount.fulfilled, (state) => {
        state.LoadingContactDetails = false;
        toast.success("Account removed successfully");
      })
      .addCase(unlinkClientAccount.rejected, (state) => {
        state.LoadingContactDetails = false;
        toast.error("Failed to delete account! Please try again");
      });
  },
});

export const getLinkedAccounts = createAsyncThunk<ClientContactDetailsModel[]>(
  "LinkedAccounts/getLinkedAccounts",
  async () => {
    const clientPortalAccountContactDetailsService = container.get<IClientPortalAccountContactDetailsService>(
      SERVICE_TYPES.ClientPortalAccountContactDetailsService
    );
    return await clientPortalAccountContactDetailsService.getClientContactDetails();
  }
);

export const unlinkClientAccount = createAsyncThunk<void, { clientPortalUserID: string; clientID: string }>(
  "LinkedAccounts/unlinkClientAccount",
  async ({ clientPortalUserID, clientID }) => {
    const clientPortalUsersService = container.get<IClientPortalUsersService>(SERVICE_TYPES.ClientPortalUsersService);
    await clientPortalUsersService.unlinkClientAccount(clientPortalUserID, clientID);

    const sessionService = container.get<ISessionService>(SERVICE_TYPES.SessionService);
    await sessionService.refreshCPLToken(true);
  }
);

export const selectClientContactDetails = (state: RootState) => {
  return state.linkedAccounts.ClientContactDetails;
};

export const selectLoadingClientContactDetails = (state: RootState) => state.linkedAccounts.LoadingContactDetails;

export default LinkedAccountsSlice.reducer;
